{
  "helloWorld": "Witaj, Świecie!",
  "clickMe": "Kliknij mnie",
  "healthCheckFailed": "Sprawdzenie stanu nie powiodło się",
  "errors": {
    "unexpected": "Wystąpił nieoczekiwany błąd"
  },
  "error": {
    "title": "Coś poszło nie tak",
    "description": "Wystąpił nieoczekiwany błąd. Możesz spróbować ponownie lub wrócić na stronę główną.",
    "tryAgain": "Spróbuj ponownie",
    "goHome": "Strona główna"
  },
  "dev": {
    "errorPreview": "Podgląd błędu"
  },
  "actions": {
    "label": "Akcje",
    "edit": "Edytuj",
    "delete": "Usuń",
    "save": "Zapisz",
    "cancel": "Anuluj",
    "expand": "Rozwiń",
    "collapse": "Zwiń"
  },
  "validation": {
    "tooLong": "Maksymalnie {{max}} znaków",
    "tooShort": "Wymagane",
    "invalidFormat": "Nieprawidłowy format",
    "invalid": "Nieprawidłowa wartość"
  },
  "nav": {
    "workspace": "Przestrzeń robocza",
    "controlCenter": "Centrum sterowania",
    "jobs": "Oferty pracy",
    "analytics": "Analityka",
    "company": "Firma",
    "agentCommunications": "Komunikacja agenta",
    "integrations": "Integracje",
    "suggestedCandidates": "Sugerowani kandydaci",
    "unsolicitedApplications": "Aplikacje spontaniczne",
    "team": "Zespół",
    "templates": "Szablony",
    "workflow": "Przepływ pracy",
    "settings": "Ustawienia",
    "language": "Język",
    "help": "Pomoc",
    "logout": "Wyloguj się",
    "administration": "Administracja",
    "adminTenant": "Ustawienia najemcy",
    "adminOrganizations": "Organizacje",
    "adminDepartments": "Działy",
    "adminFeedback": "Opinie",
    "openMenu": "Otwórz menu",
    "mcp": "MCP",
    "orgSettings": "Ustawienia organizacji"
  },
  "admin": {
    "tenants": {
      "title": "Najemcy",
      "newTenant": "Nowy najemca",
      "columns": {
        "name": "Nazwa",
        "createdAt": "Utworzono",
        "actions": "Akcje"
      },
      "createDialog": {
        "title": "Utwórz najemcę",
        "namePlaceholder": "Acme Corp"
      },
      "editDialog": {
        "title": "Edytuj najemcę"
      }
    },
    "tenant": {
      "title": "Ustawienia najemcy",
      "name": "Nazwa najemcy",
      "save": "Zapisz zmiany",
      "saved": "Zapisano"
    },
    "organizations": {
      "title": "Organizacje",
      "newOrg": "Nowa organizacja",
      "columns": {
        "name": "Nazwa",
        "slug": "Slug",
        "tenant": "Najemca",
        "createdAt": "Utworzono",
        "actions": "Akcje",
        "viewWorkspace": "Pokaż przestrzeń roboczą"
      },
      "createDialog": {
        "title": "Utwórz organizację",
        "namePlaceholder": "Acme Corp",
        "slugPlaceholder": "acme-corp",
        "newTenant": "Nowy najemca",
        "existingTenant": "Istniejący najemca",
        "tenantName": "Nazwa najemcy",
        "tenantNamePlaceholder": "Acme Corp",
        "selectTenant": "Wybierz najemcę"
      },
      "editDialog": {
        "title": "Edytuj organizację",
        "language": "Język",
        "languagePlaceholder": "Wybierz język"
      },
      "deleteConfirm": {
        "title": "Usuń organizację",
        "description": "Spowoduje to również usunięcie wszystkich działów w tej organizacji. Tej operacji nie można cofnąć.",
        "confirm": "Usuń",
        "cancel": "Anuluj"
      }
    },
    "departments": {
      "title": "Działy",
      "newDept": "Nowy dział",
      "columns": {
        "name": "Nazwa",
        "slug": "Slug",
        "createdAt": "Utworzono",
        "actions": "Akcje"
      },
      "createDialog": {
        "title": "Utwórz dział",
        "namePlaceholder": "Inżynieria",
        "slugPlaceholder": "inzynieria"
      },
      "editDialog": {
        "title": "Edytuj dział"
      },
      "deleteConfirm": {
        "title": "Usuń dział",
        "description": "Tej operacji nie można cofnąć.",
        "confirm": "Usuń",
        "cancel": "Anuluj"
      }
    },
    "viewingOrg": {
      "banner": "Przeglądanie: {{name}}",
      "leave": "Opuść"
    },
    "feedback": {
      "title": "Opinie",
      "columns": {
        "rating": "Ocena",
        "modality": "Typ",
        "candidate": "Kandydat",
        "job": "Oferta pracy",
        "org": "Organizacja",
        "notes": "Uwagi",
        "date": "Data"
      },
      "modality": {
        "voice": "Głos",
        "text": "Czat"
      },
      "thumbs": {
        "up": "Pozytywna",
        "down": "Negatywna"
      },
      "filter": {
        "all": "Wszystkie",
        "up": "Pozytywne",
        "down": "Negatywne",
        "hasNotes": "Z uwagami"
      },
      "stats": {
        "title": "Wskaźnik negatywnych",
        "period": "Ostatnie 7 dni",
        "wowUp": "+{{delta}}pp",
        "wowDown": "-{{delta}}pp",
        "wowFlat": "Bez zmian",
        "wowNoPrev": "Brak poprzednich danych",
        "noData": "Brak danych"
      },
      "noFeedback": "Brak opinii",
      "noNotes": "Brak komentarza"
    }
  },
  "team": {
    "title": "Zespół",
    "invite": "Zaproś współpracowników",
    "search": "Szukaj po imieniu, e-mailu, dziale...",
    "department": "Dział",
    "roles": {
      "admin": "Administrator",
      "org_manager": "Menedżer organizacji",
      "dept_manager": "Menedżer działu",
      "user": "Użytkownik"
    },
    "columns": {
      "name": "Imię i nazwisko",
      "email": "E-mail",
      "role": "Rola",
      "actions": "Akcje"
    },
    "inviteDialog": {
      "title": "Zaproś współpracownika",
      "name": "Imię i nazwisko",
      "namePlaceholder": "Jan Kowalski",
      "email": "Adres e-mail",
      "emailPlaceholder": "kolega@firma.pl",
      "role": "Rola",
      "departments": "Działy",
      "submit": "Wyślij zaproszenie"
    },
    "actions": {
      "changeRole": "Zmień rolę",
      "addDepartment": "Dodaj do działu",
      "removeDepartment": "Usuń z działu",
      "removeFromOrg": "Usuń z organizacji"
    },
    "noResults": "Nie znaleziono wyników.",
    "noMembers": "Brak członków zespołu."
  },
  "jobs": {
    "title": "Oferty pracy",
    "backToJobs": "Oferty pracy",
    "newJob": "Nowa oferta",
    "createNewJob": "Utwórz nową ofertę",
    "importFromAts": "Importuj z {{atsName}}",
    "searchPlaceholder": "Szukaj ofert pracy...",
    "completedPlaceholder": "{{completed}} z {{total}} ukończonych",
    "tabs": {
      "active": "Aktywne",
      "archived": "Zarchiwizowane"
    },
    "columns": {
      "name": "Nazwa",
      "createdBy": "Utworzone przez",
      "createdAt": "Utworzono",
      "actions": "Akcje"
    },
    "empty": "Nie znaleziono ofert pracy.",
    "emptyTitle": "Brak ofert pracy",
    "emptyDescription": "Utwórz pierwszą ofertę pracy lub zaimportuj z ATS, aby rozpocząć.",
    "emptyArchivedTitle": "Brak zarchiwizowanych ofert",
    "emptyArchivedDescription": "Zarchiwizowane oferty pojawią się tutaj.",
    "emptySearchDescription": "Żadna oferta nie pasuje do wyszukiwania.",
    "actions": {
      "archive": "Archiwizuj",
      "archiveConfirmTitle": "Archiwizuj ofertę",
      "archiveConfirmDescription": "Czy na pewno chcesz zarchiwizować tę ofertę? Zostanie przeniesiona do zakładki Zarchiwizowane.",
      "archiveSuccess": "Oferta zarchiwizowana",
      "archiveError": "Nie udało się zarchiwizować oferty. Spróbuj ponownie."
    },
    "createError": "Nie udało się utworzyć oferty. Spróbuj ponownie.",
    "status": {
      "active": "Aktywna",
      "archived": "Zarchiwizowana"
    },
    "setupStatus": {
      "draft": "Szkic",
      "questions_pending": "Wymaga konfiguracji",
      "ready": "Gotowa",
      "active": "Aktywna"
    },
    "applicantSync": {
      "syncingBanner": "Pobieranie kandydatów z {{provider}}...",
      "failedBanner": "Synchronizacja kandydatów nie powiodła się",
      "adminActions": "Akcje administracyjne",
      "resyncLabel": "Synchronizuj kandydatów teraz",
      "lastSyncedAt": "Ostatnia synchronizacja: {{date}}",
      "addDemoApplicant": "Dodaj kandydata demo"
    },
    "detail": {
      "tabs": {
        "candidates": "Kandydaci",
        "results": "Wyniki",
        "settings": "Ustawienia"
      },
      "info": {
        "title": "Informacje o ofercie",
        "employer": "Pracodawca",
        "location": "Lokalizacja",
        "description": "Opis",
        "modality": "Forma rozmowy",
        "languages": "Języki",
        "atsProvider": "Dostawca ATS",
        "atsId": "ID oferty w ATS",
        "noDescription": "Brak opisu."
      },
      "questions": {
        "title": "Pytania rozmowy kwalifikacyjnej",
        "empty": "Brak skonfigurowanych pytań dla tej oferty.",
        "optional": "Opcjonalne",
        "categories": {
          "eligibility": "Kwalifikowalność",
          "nice_to_have": "Mile widziane",
          "job_preview": "Oczekiwania stanowiskowe",
          "assessment": "Ocena",
          "information": "Informacje"
        }
      }
    }
  },
  "wizard": {
    "step": "Krok {{current}} z {{total}}",
    "back": "Wstecz",
    "next": "Kontynuuj",
    "goLive": "Aktywuj",
    "saveAndContinue": "Zapisz i kontynuuj",
    "manual": {
      "title": "Nowa oferta",
      "step1Title": "Podstawowe informacje",
      "step2Title": "Pytania rozmowy",
      "step3Title": "Potwierdź i aktywuj"
    },
    "import": {
      "title": "Importuj z ATS",
      "step0Title": "Wybierz oferty",
      "step1Title": "Mapuj etapy",
      "step2Title": "Ustawienia rozmowy",
      "step3Title": "Pytania rozmowy",
      "step4Title": "Potwierdź i aktywuj"
    },
    "stageSelector": {
      "title": "Mapuj etapy procesu",
      "description": "Wybierz, który etap w każdej ofercie odpowiada poszczególnym akcjom Kiku. Wstępnie wypełnione tam, gdzie nazwy etapów pasowały do domyślnych.",
      "continue": "Kontynuuj",
      "loading": "Ładowanie etapów…"
    },
    "basicInfo": {
      "title": "Tytuł oferty",
      "titlePlaceholder": "np. Starszy inżynier oprogramowania",
      "description": "Opis stanowiska",
      "descriptionPlaceholder": "Opisz rolę, obowiązki i wymagania...",
      "descriptionHint": "Używane przez AI do generowania trafnych pytań rozmowy",
      "employer": "Nazwa pracodawcy (opcjonalnie)",
      "employerPlaceholder": "np. Acme Corp",
      "modality": "Format rozmowy",
      "modalityText": "Czat tekstowy",
      "modalityTextDesc": "Kandydat wpisuje odpowiedzi w interfejsie czatu",
      "modalityVoice": "Rozmowa głosowa",
      "modalityVoiceDesc": "Rozmowa audio na żywo w wirtualnym pokoju spotkań",
      "languages": "Język(i) rozmowy",
      "languagesHint": "Wybierz co najmniej jeden język",
      "languagesSearch": "Szukaj języków…",
      "languagesEmpty": "Nie znaleziono języka.",
      "modalityRequired": "Wybierz co najmniej jeden format rozmowy",
      "languagesRequired": "Wybierz co najmniej jeden język"
    },
    "atsSelector": {
      "title": "Wybierz oferty do importu",
      "search": "Szukaj ofert...",
      "selectAll": "Zaznacz wszystkie",
      "selected": "{{count}} zaznaczonych",
      "noJobs": "Nie znaleziono aktywnych ofert w Twoim ATS",
      "noDescription": "Brak opisu — AI wygeneruje pytania na podstawie samego tytułu",
      "continue": "Kontynuuj z {{count}} ofertą/ofertami"
    },
    "sharedSettings": {
      "title": "Ustawienia rozmowy",
      "subtitle": "Te ustawienia zostaną zastosowane do wszystkich importowanych ofert",
      "employer": "Nazwa pracodawcy",
      "employerPlaceholder": "np. Acme Corp"
    },
    "questions": {
      "title": "Pytania rozmowy",
      "generateError": "Nie udało się wygenerować pytań. Spróbuj ponownie.",
      "retry": "Ponów",
      "generating": "Przygotowywanie pytań, aby znaleźć najlepszych kandydatów…",
      "generatingHint": "To zwykle trwa kilka sekund",
      "addQuestion": "Dodaj pytanie",
      "categories": {
        "eligibility": "Kwalifikowalność",
        "nice_to_have": "Mile widziane",
        "job_preview": "Realistyczny podgląd stanowiska",
        "assessment": "Ocena",
        "information": "Zbieranie informacji"
      },
      "categoryDescriptions": {
        "eligibility": "Pytania tak/nie dotyczące wymagań obowiązkowych",
        "nice_to_have": "Pytania tak/nie dotyczące pożądanych, ale niewymaganych kwalifikacji",
        "job_preview": "Przedstawia wymagający aspekt roli. Pomaga upewnić się, że kandydat rozumie, na czym polega stanowisko i zapobiega rezygnacjom",
        "assessment": "Pytania behawioralne i kompetencyjne",
        "information": "Pytania do zbierania kontekstu — nie używane w ocenie"
      },
      "categoryPurpose": {
        "eligibility": "Zdane lub niezdane",
        "job_preview": "Zdane lub niezdane",

        "assessment": "Punktowane",
        "information": "Tylko informacyjnie"
      },
      "optional": "Opcjonalne",
      "competency": "Kompetencja",
      "scoringExamples": "Kotwice oceny",
      "editScoringExamples": "Edytuj kotwice oceny",
      "regenerateScoringExamples": "Wygeneruj ponownie kotwice oceny",
      "dontRegenerateScoringExamples": "Nie generuj ponownie kotwic oceny",
      "regeneratingScoringExamples": "Regenerowanie...",
      "regenerateScoringError": "Nie udało się wygenerować ponownie kotwic oceny",
      "score1": "Ocena 1 — Słaba",
      "score3": "Ocena 3 — Wystarczająca",
      "score5": "Ocena 5 — Doskonała",
      "aiGenerated": "Wygenerowane przez AI"
    },
    "confirm": {
      "title": "Gotowe do aktywacji",
      "jobsCount": "{{count}} ofert(a) zostanie aktywowanych",
      "questionsCount": "{{count}} pytań rozmowy",
      "modality": "Format",
      "languages": "Języki",
      "goLiveHint": "Kandydaci będą mogli rozpocząć rozmowy natychmiast po aktywacji."
    }
  },
  "login": {
    "title": "Zaloguj się do Kiku",
    "subtitle": "Zarządzaj swoim procesem rekrutacji.",
    "cta": "Zaloguj się",
    "waitingForLogin": "Oczekiwanie na logowanie…",
    "disclosure": "Korzystasz z systemu AI. Kiku wykorzystuje AI do wsparcia rekrutacji — wszystkie decyzje podlegają weryfikacji przez człowieka.",
    "errors": {
      "not_provisioned": "Twoje konto nie zostało jeszcze skonfigurowane. Skontaktuj się z administratorem.",
      "missing_code": "Uwierzytelnianie nie powiodło się. Spróbuj ponownie.",
      "session_expired": "Twoja sesja wygasła. Zaloguj się ponownie."
    }
  },
  "settings": {
    "profile": {
      "title": "Profil",
      "name": "Imię i nazwisko",
      "email": "E-mail",
      "role": "Rola",
      "departments": "Działy"
    }
  },
  "integrations": {
    "title": "Integracje",
    "ats": {
      "title": "Połączenie z ATS",
      "description": "Połącz swój system śledzenia kandydatów, aby synchronizować oferty pracy i zarządzać etapami kandydatów.",
      "provider": "Dostawca",
      "apiKey": "Klucz API",
      "apiKeyPlaceholder": "Wprowadź swój klucz API",
      "apiKeySet": "Klucz zapisany — wprowadź nową wartość, aby go zastąpić",
      "save": "Zapisz połączenie",
      "verify": "Zweryfikuj połączenie",
      "verifyStatus": {
        "valid": "Połączono",
        "invalid": "Nieprawidłowy klucz",
        "error": "Weryfikacja nie powiodła się",
        "idle": "Niezweryfikowany",
        "loading": "Weryfikowanie..."
      },
      "providers": {
        "teamtailor": "Teamtailor",
        "recman": "RecMan",
        "logicmelon": "LogicMelon",
        "teamtailorDescription": "Teamtailor to platforma rekrutacyjna, która pomaga firmom przyciągać, rozwijać i zatrudniać najlepszych kandydatów.",
        "recmanDescription": "RecMan to system rekrutacyjny dla agencji pracy tymczasowej i rekrutacyjnych na rynku nordyckim.",
        "logicmelonDescription": "LogicMelon to system ATS z wielokrotnym publikowaniem ofert, przeznaczony do rekrutacji na dużą skalę, popularny w brytyjskim sektorze edukacyjnym."
      }
    },
    "stageMapping": {
      "title": "Mapowanie etapów",
      "description": "Zmapuj etapy ATS na etapy przepływu pracy Kiku.",
      "initialStage": "Etap początkowy",
      "passInterviewStage": "Rozmowa zaliczona",
      "failInterviewStage": "Rozmowa niezaliczona",
      "recommendedStage": "Rekomendowany",
      "selectStage": "Wybierz etap",
      "save": "Zapisz mapowanie"
    },
    "errors": {
      "notConfigured": "Brak skonfigurowanego ATS. Najpierw zapisz połączenie.",
      "fetchStagesFailed": "Nie udało się załadować etapów z ATS.",
      "saveFailed": "Nie udało się zapisać konfiguracji."
    }
  },
  "applications": {
    "title": "Aplikacje",
    "newCandidate": "Nowy kandydat",
    "addCandidate": "Dodaj nowego kandydata",
    "importFromCsv": "Importuj z CSV",
    "importDialog": {
      "title": "Importuj kandydatów",
      "back": "Wstecz",
      "next": "Dalej",
      "upload": {
        "hint": "Przeciągnij i upuść plik CSV tutaj lub kliknij, aby przeglądać",
        "csvOnly": "Tylko pliki CSV",
        "browse": "Przeglądaj"
      },
      "mapping": {
        "headerRow": "Pierwszy wiersz to nagłówek",
        "nameColumn": "Kolumna imienia",
        "emailColumn": "Kolumna e-maila",
        "phoneColumn": "Kolumna telefonu",
        "notMapped": "— niezmapowane —",
        "column": "Kolumna",
        "preview": "Podgląd"
      },
      "review": {
        "allValid": "Wszystkich {{count}} kandydatów jest prawidłowych",
        "summary": "{{valid}} prawidłowych · {{invalid}} nieprawidłowych",
        "skipInvalid": "Pomiń nieprawidłowe wiersze i zaimportuj {{count}} prawidłowych kandydatów",
        "recheck": "Sprawdź ponownie",
        "import": "Importuj {{count}} kandydatów",
        "colName": "Imię i nazwisko",
        "colEmail": "E-mail",
        "colPhone": "Telefon",
        "colStatus": "Status"
      },
      "errors": {
        "nameRequired": "Wymagane",
        "emailInvalid": "Nieprawidłowy e-mail",
        "emailDuplicate": "Zduplikowany e-mail w tym pliku",
        "phoneInvalid": "Wymagany numer kierunkowy kraju (np. +48…)"
      },
      "success": {
        "title": "Import zakończony",
        "body": "{{created}} zaimportowanych, {{conflict}} miało już aplikacje (pominięto), {{error}} nieudanych.",
        "done": "Gotowe"
      }
    },
    "screening": "Rekrutacja wstępna",
    "aiRanked": "Ranking AI",
    "emptyStage": "Brak aplikacji",
    "emptyTitle": "Brak kandydatów",
    "emptyDescription": "Dodaj pierwszego kandydata, aby rozpocząć przeglądanie aplikacji.",
    "emptySearchDescription": "Żaden kandydat nie pasuje do wyszukiwania.",
    "searchPlaceholder": "Szukaj po imieniu, e-mailu lub telefonie",
    "createDialog": {
      "title": "Dodaj aplikację",
      "name": "Imię i nazwisko",
      "namePlaceholder": "np. Jan Kowalski",
      "email": "Adres e-mail",
      "emailPlaceholder": "np. jan@example.com",
      "phoneNumber": "Numer telefonu",
      "phoneNumberPlaceholder": "np. 555-1234",
      "phoneCountryCode": "Numer kierunkowy",
      "phoneCountryCodePlaceholder": "np. +48",
      "submit": "Utwórz aplikację"
    },
    "errors": {
      "conflict": "Ten kandydat ma już aplikację na tę ofertę."
    },
    "detail": {
      "title": "Szczegóły aplikacji",
      "tabs": {
        "application": "Aplikacja",
        "profile": "Profil",
        "activity": "Aktywność"
      },
      "stage": "Etap",
      "interviewLink": "Link do rozmowy",
      "interviewStatus": "Status rozmowy",
      "copyLink": "Kopiuj link",
      "linkCopied": "Skopiowano!",
      "noInterview": "Nie znaleziono sesji rozmowy",
      "noResults": {
        "title": "Rozmowa nieukończona",
        "description": "Kandydat nie odbył jeszcze rozmowy. Udostępnij link do rozmowy, aby rozpocząć."
      },
      "inProgress": {
        "title": "Rozmowa w toku",
        "description": "Kandydat rozpoczął rozmowę. Wyniki pojawią się tutaj po jej zakończeniu."
      },
      "openInterview": "Otwórz rozmowę",
      "commChannel": {
        "label": "Wyślij przez",
        "manual": "Ręcznie",
        "email": "E-mail",
        "sms": "SMS",
        "whatsapp": "WhatsApp"
      },
      "status": {
        "pending": "Oczekujące",
        "in_progress": "W trakcie",
        "completed": "Ukończone",
        "expired": "Wygasłe"
      }
    }
  },
  "pagination": {
    "rowsPerPage": "Wierszy na stronę",
    "rowsSelected": "{{count}} z {{total}} wierszy zaznaczonych.",
    "pageOf": "Strona {{page}} z {{total}}",
    "previous": "Poprzednia",
    "next": "Następna"
  },
  "screening": {
    "title": "Rozmowa kwalifikacyjna",
    "aiDisclosure": "Rozmawiasz z Sara, asystentem rekrutacyjnym AI",
    "selectLanguage": "Wybierz preferowany język",
    "selectLanguageDescription": "Rozmowa zostanie przeprowadzona w wybranym przez Ciebie języku",
    "startInterview": "Rozpocznij rozmowę",
    "previewJobTitle": "Przykładowa oferta — Przykładowa firma",
    "typeMessage": "Wpisz wiadomość...",
    "send": "Wyślij",
    "typing": "Sara pisze...",
    "submitInterview": "Wyślij rozmowę",
    "loading": "Ładowanie rozmowy...",
    "completed": {
      "title": "Rozmowa zakończona",
      "submitted": "Rozmowa została pomyślnie przesłana",
      "message": "Dziękujemy za ukończenie rozmowy na stanowisko {{jobTitle}}. Rekruter przejrzy Twoje odpowiedzi i skontaktuje się z Tobą."
    },
    "expired": {
      "title": "Rozmowa wygasła",
      "message": "Link do tej rozmowy wygasł. Skontaktuj się z rekruterem w celu uzyskania nowego zaproszenia."
    },
    "notFound": {
      "title": "Nie znaleziono rozmowy",
      "message": "Ten link do rozmowy jest nieprawidłowy. Sprawdź link i spróbuj ponownie."
    },
    "feedback": {
      "helpUsImprove": "Pomóż nam się poprawić",
      "teaser": "Jak oceniasz doświadczenie z rozmowy?",
      "overallPrompt": "Jak oceniasz ogólne wrażenie z rozmowy?",
      "disclaimer": "Chętnie poznamy Twoją opinię — jest anonimowa i nie wpłynie na Twoją aplikację.",
      "prompt": "Jak przebiegła rozmowa?",
      "good": "Świetnie",
      "bad": "Źle",
      "notesLabel": "Dodatkowe uwagi?",
      "notesPlaceholder": "Powiedz nam więcej (opcjonalnie)...",
      "skip": "Pomiń",
      "submit": "Prześlij opinię",
      "submitError": "Nie udało się przesłać opinii. Spróbuj ponownie."
    },
    "technicalIssue": {
      "buttonLabel": "Problem techniczny?",
      "modalTitle": "Zgłoś problem techniczny",
      "modalDescription": "Opisz napotkany problem. Twoja opinia zostanie wysłana, a rozmowa zostanie uruchomiona ponownie.",
      "notesLabel": "Co poszło nie tak?",
      "notesPlaceholder": "np. Strona się zawiesiła i straciłem/am postęp...",
      "submitButton": "Wyślij opinię i uruchom ponownie",
      "submitError": "Nie udało się przesłać. Spróbuj ponownie.",
      "cancel": "Anuluj"
    },
    "error": {
      "title": "Coś poszło nie tak",
      "message": "Wystąpił błąd. Spróbuj ponownie później.",
      "sendFailed": "Nie udało się wysłać wiadomości. Spróbuj ponownie."
    },
    "languages": {
      "en": "Angielski",
      "da": "Duński",
      "sv": "Szwedzki",
      "de": "Niemiecki",
      "fr": "Francuski",
      "es": "Hiszpański",
      "nl": "Niderlandzki",
      "pl": "Polski",
      "fi": "Fiński",
      "ro": "Rumuński"
    },
    "landing": {
      "badge": "ROZMOWA KWALIFIKACYJNA",
      "greeting": "Cześć {{name}}! Cieszymy się, że tu jesteś. To zaproszenie na krótką wstępną rozmowę kwalifikacyjną online z AI, abyśmy mogli Cię lepiej poznać. Rozpocznij, gdy będziesz gotowy/a.",
      "startChat": "Rozpocznij rozmowę tekstową",
      "startVoice": "Rozpocznij rozmowę głosową",
      "or": "lub",
      "minutes": "{{count}} minut",
      "questions": "{{count}} pytań"
    },
    "modality": {
      "title": "Wybierz format rozmowy",
      "description": "Wybierz, w jaki sposób chcesz odbyć rozmowę",
      "text": "Rozmowa tekstowa",
      "textDescription": "Wpisuj odpowiedzi na czacie",
      "voice": "Rozmowa głosowa",
      "voiceDescription": "Odpowiadaj głosowo"
    },
    "deviceTest": {
      "title": "Sprawdź dźwięk",
      "description": "Upewnij się, że mikrofon i głośniki działają przed rozpoczęciem",
      "microphone": "Mikrofon",
      "speakers": "Głośniki",
      "testMicrophone": "Zezwól na dostęp do mikrofonu",
      "testSpeakers": "Odtwórz dźwięk testowy",
      "playAgain": "Odtwórz ponownie",
      "requestingPermission": "Żądanie uprawnień...",
      "microphoneDenied": "Odmówiono dostępu do mikrofonu. Zezwól na dostęp w ustawieniach przeglądarki.",
      "confirm": "Wszystko działa — rozpocznij rozmowę"
    },
    "voice": {
      "title": "Rozmowa głosowa",
      "connecting": "Łączenie...",
      "recording": "Nagrywanie",
      "interviewInProgress": "Rozmowa w toku",
      "inProgress": "Rozmowa w toku — mów naturalnie",
      "muted": "Twój mikrofon jest wyciszony",
      "finished": "Rozmowa zakończona — dziękujemy!",
      "alreadyInProgress": "Rozmowa w toku",
      "alreadyInProgressMessage": "Twoja rozmowa głosowa jest obecnie aktywna. Ponowne uruchomienie anuluje bieżącą sesję — rób to tylko, jeśli nie jesteś już połączony.",
      "retryButton": "Uruchom ponownie rozmowę"
    }
  },
  "scoring": {
    "title": "Wyniki rozmowy",
    "pending": "Ocenianie w toku...",
    "processing": "AI ocenia rozmowę...",
    "failed": "Ocenianie nie powiodło się",
    "overallScore": "Wynik ogólny",
    "overallScoreTooltip": "Wynik od 0 do 100 oparty na średniej wszystkich ocen pytań, skorygowany o kwalifikowalność i oczekiwania stanowiskowe.",
    "outcome": "Rezultat",
    "outcomes": {
      "pass": "Zdana",
      "fail": "Niezdana"
    },
    "summary": "Podsumowanie",
    "eligibility": "Kwalifikowalność",
    "niceToHave": "Mile widziane",
    "expectations": "Oczekiwania stanowiskowe",
    "assessment": "Ocena",
    "information": "Zbieranie informacji",
    "scoringAnchors": "Kotwice oceny",
    "candidateAnswer": "Odpowiedź kandydata",
    "transcript": "Transkrypcja rozmowy",
    "viewInTranscript": "Zobacz w transkrypcji",
    "copyPasteDetected": "Skopiowana odpowiedź",
    "copyPasteWarning": "Wykryto kopiuj-wklej w tej rozmowie",
    "copyPasteWarningTooltip": "Jedna lub więcej odpowiedzi kandydata została wklejona podczas rozmowy. Może to oznaczać, że kandydat użył wcześniej przygotowanych odpowiedzi.",
    "verdicts": {
      "pass": "Zdane",
      "fail": "Niezdane",
      "unsure": "Niepewne",
      "review": "Wymaga przeglądu"
    },
    "optional": "Opcjonalne",
    "averageScore": "Średnia ocena pytań",
    "reasoning": "Uzasadnienie",
    "evidence": "Dowody",
    "backToJob": "Wróć do oferty",
    "overrideDialog": {
      "title": "Nadpisz ocenę",
      "titleVerdict": "Nadpisz werdykt",
      "currentValue": "Aktualna wartość",
      "newValue": "Nowa wartość",
      "reason": "Powód nadpisania",
      "reasonPlaceholder": "Wyjaśnij, dlaczego zmieniasz tę ocenę...",
      "reasonMinLength": "Wymagane minimum {{min}} znaków",
      "save": "Zapisz nadpisanie",
      "cancel": "Anuluj",
      "error": "Nie udało się zapisać nadpisania. Spróbuj ponownie."
    }
  },
  "workflows": {
    "title": "Przepływ pracy",
    "description": "Skonfiguruj etapy, przez które przechodzą aplikacje podczas procesu rekrutacji.",
    "stages": {
      "title": "Etapy procesu",
      "subtitle": "Przeciągnij, aby zmienić kolejność. Aplikacje przechodzą przez te etapy od góry do dołu.",
      "system": "Systemowy",
      "manage": "Zarządzaj etapami",
      "addStage": "Dodaj etap",
      "editStage": "Edytuj etap",
      "deleteStage": "Usuń etap",
      "stageName": "Nazwa etapu",
      "stageNamePlaceholder": "np. Rozmowa telefoniczna",
      "stageColor": "Kolor",
      "deleteConfirm": "Usunąć ten etap? Aplikacje na tym etapie muszą zostać najpierw przeniesione.",
      "systemProtected": "Etapy systemowe nie mogą zostać usunięte",
      "hasApplications": "Ten etap ma jeszcze przypisane aplikacje"
    }
  },
  "communications": {
    "title": "Komunikacja agenta",
    "languageSelector": "Język",
    "tabs": {
      "sms": "SMS",
      "email": "E-mail"
    },
    "emailSubject": "Temat",
    "emailBody": "Treść",
    "variables": {
      "applicantName": "Imię kandydata",
      "jobTitle": "Tytuł oferty",
      "jobEmployer": "Pracodawca",
      "jobLocation": "Lokalizacja oferty",
      "jobDescription": "Opis oferty",
      "recruiterName": "Imię rekrutera",
      "inviteUrl": "URL zaproszenia"
    },
    "actions": {
      "edit": "Edytuj",
      "save": "Zapisz zmiany",
      "reset": "Przywróć domyślne",
      "saved": "Szablon zapisany",
      "resetDone": "Przywrócono domyślne"
    },
    "nodes": {
      "interviewIntro": "Wstęp do rozmowy",
      "interviewOutro": "Zakończenie rozmowy",
      "reminderToFinish": "Przypomnienie o ukończeniu",
      "voiceAndChat": "Głos i czat",
      "emailsAndSms": "E-maile i SMS",
      "comingSoon": "Wkrótce"
    },
    "characters": "{{count}}/{{max}} Znaków",
    "smsSegments": "{{count}} wiadomości SMS ({{size}} znaków/segment)",
    "smsUnicodeWarning": "Ta wiadomość zawiera emoji lub znaki specjalne wymagające kodowania Unicode, co zmniejsza limit do 67 znaków na SMS.",
    "invite": {
      "title": "Zaproszenie dla kandydata",
      "description": "Kandydaci otrzymują to po dodaniu do oferty pracy. E-mail automatycznie zawiera link do rozmowy.",
      "email": {
        "subject": "Zaproszenie na rozmowę kwalifikacyjną — {{jobTitle}}! 🎯",
        "body": "<p>Cześć {{applicantName}},</p><p>Zapraszamy do odbycia krótkiej wstępnej rozmowy kwalifikacyjnej online z naszym AI na stanowisko <strong>{{jobTitle}}</strong> w firmie <strong>{{jobEmployer}}</strong>.</p><p>To prosty sposób, abyśmy mogli Cię lepiej poznać — możesz ją odbyć w dowolnym momencie, z dowolnego miejsca. Zajmie tylko kilka minut!</p><p><a href=\"{{inviteUrl}}\">Rozpocznij rozmowę</a></p><p>Powodzenia!<br>{{jobEmployer}}</p>"
      },
      "sms": "Cześć {{applicantName}}, jestem Sara, asystent AI ds. rekrutacji w {{jobEmployer}}. Zapraszamy na rozmowę kwalifikacyjną na stanowisko {{jobTitle}}. Zajmie to tylko kilka minut: {{inviteUrl}} (Bez odpowiedzi)"
    },
    "reminder": {
      "title": "Przypomnienie o rozmowie",
      "description": "Wysyłane automatycznie, jeśli kandydat nie rozpoczął rozmowy w ciągu 24 godzin od otrzymania zaproszenia.",
      "email": {
        "subject": "Nie zapomnij o rozmowie — {{jobTitle}}",
        "body": "<p>Cześć {{applicantName}},</p><p>Zauważyliśmy, że nie ukończyłeś/aś jeszcze wstępnej rozmowy kwalifikacyjnej AI na stanowisko <strong>{{jobTitle}}</strong> w firmie <strong>{{jobEmployer}}</strong>.</p><p>To Twoja szansa, aby przejść o krok dalej — zajmie to tylko kilka minut, a ukończenie rozmowy zwiększy Twoje szanse na przejście do kolejnego etapu.</p><p><a href=\"{{inviteUrl}}\">Ukończ rozmowę teraz</a></p><p>Pozdrawiamy,<br>{{jobEmployer}}</p>"
      },
      "sms": "Cześć {{applicantName}}, tylko przyjazne przypomnienie — nie ukończyłeś/aś jeszcze rozmowy kwalifikacyjnej na stanowisko {{jobTitle}} w {{jobEmployer}}. Zajmie to tylko kilka minut i zwiększy Twoje szanse: {{inviteUrl}} — Sara"
    },
    "emailBodyPlaceholder": "Napisz swój e-mail...",
    "preview": {
      "outroSampleIntro": "To wszystko — dziękuję za odpowiedzi!",
      "outroSampleAnswer": "Nie ma problemu, chętnie pomogę."
    },
    "intro": {
      "title": "Wstęp do rozmowy",
      "description": "Dokładna wiadomość powitalna, którą Sara wypowie, aby powitać kandydata i zapytać, czy jest gotowy do rozpoczęcia.",
      "scriptLabel": "Wiadomość wstępna",
      "scriptPlaceholder": "Napisz dokładną wiadomość powitalną, którą Sara powinna wypowiedzieć...",
      "defaultScript": "Cześć! Jestem Sara, asystent rekrutacyjny AI w {{jobEmployer}}. Dziękuję za poświęcenie czasu na rozmowę na stanowisko {{jobTitle}} — zajmie to tylko kilka minut. Czy jesteś gotowy/a do rozpoczęcia? 😊"
    },
    "outro": {
      "title": "Zakończenie rozmowy",
      "description": "Dokładna wiadomość końcowa, którą Sara wypowie po udzieleniu odpowiedzi na wszystkie pytania.",
      "scriptLabel": "Wiadomość końcowa",
      "scriptPlaceholder": "Napisz dokładną wiadomość końcową, którą Sara powinna wypowiedzieć...",
      "defaultScript": "To wszystko — bardzo dziękuję za Twój czas! Rekruter przejrzy Twoje odpowiedzi i skontaktuje się z Tobą. Powodzenia! 🙂"
    }
  },
  "activity": {
    "title": "Aktywność",
    "stageChange": "Przeniesiono z {{from}} do {{to}}",
    "interviewCompleted": "Ukończono rozmowę kwalifikacyjną",
    "scoreReceived": "Otrzymano wynik: {{score}}/100",
    "applicationCreated": "Utworzono aplikację",
    "noteAdded": "Dodano notatkę",
    "bySystem": "System",
    "byAi": "AI",
    "empty": "Brak aktywności",
    "emptyTitle": "Brak aktywności",
    "emptyDescription": "Akcje i zdarzenia dotyczące tego kandydata pojawią się tutaj."
  },
  "atsPush": {
    "title": "Status wysyłki do ATS",
    "retry": "Ponów wysyłkę do ATS",
    "retrying": "Ponawianie...",
    "rerunStep": "Uruchom ten krok ponownie",
    "rerunConfirm": "Ten krok został już pomyślnie ukończony. Ponowne uruchomienie może spowodować duplikaty danych w ATS. Kontynuować?",
    "steps": {
      "transcript": "Transkrypcja",
      "stage_move": "Zmiana etapu"
    },
    "status": {
      "completed": "Wysłano",
      "failed": "Nieudane",
      "pending": "Oczekujące"
    },
    "note": {
      "title": "Wstępna rozmowa kwalifikacyjna AI",
      "outcome": "Rezultat",
      "score": "Wynik",
      "summary": "Podsumowanie",
      "eligibility": "Kwalifikowalność",
      "assessment": "Ocena",
      "transcript": "Transkrypcja",
      "candidate": "Kandydat",
      "interviewer": "Prowadzący",
      "pass": "Zdane",
      "fail": "Niezdane",
      "review": "Przegląd",
      "shortlist": "Lista krótka",
      "reject": "Odrzuć",
      "viewProfile": "Zobacz profil kandydata w Kiku",
      "transcriptAndAssessment": "TRANSKRYPCJA I OCENA",
      "intro": "Wstęp",
      "eligibilityQuestions": "Pytania o kwalifikowalność",
      "jobExpectations": "Oczekiwania stanowiskowe",
      "assessmentQuestions": "Pytania oceniające",
      "outro": "Zakończenie",
      "assessmentExplanation": "WYJAŚNIENIE OCENY",
      "unsure": "Niepewne",
      "viewInKiku": "OTWÓRZ W KIKU, ABY ZOBACZYĆ WIĘCEJ SZCZEGÓŁÓW",
      "viewProfileLink": "Zobacz profil kandydata w Kiku, aby zobaczyć wyjaśnienia ocen"
    }
  },
  "topbar": {
    "whatsNew": "Co nowego",
    "help": "Pomoc",
    "notifications": "Powiadomienia"
  },
  "extension_candidate_banner": {
    "description": "Zobacz szczegóły kandydata.",
    "description_with_transcript": "Zobacz transkrypcję rozmowy i szczegóły kandydata.",
    "open_in_kiku": "Otwórz",
    "dismiss": "Odrzuć"
  },
  "languages": {
    "en": "Angielski",
    "da": "Duński",
    "sv": "Szwedzki",
    "de": "Niemiecki",
    "fr": "Francuski",
    "es": "Hiszpański",
    "nl": "Niderlandzki",
    "pl": "Polski",
    "fi": "Fiński",
    "ro": "Rumuński"
  },
  "environmentBanner": {
    "development": "Rozwój",
    "test": "Test"
  },
  "notFound": {
    "title": "Nie znaleziono strony",
    "description": "Strona, której szukasz, nie istnieje lub została przeniesiona.",
    "goHome": "Wróć do Kiku"
  },
  "candidateProfile": {
    "title": "Kandydaci",
    "cv": {
      "title": "CV / Życiorys",
      "upload": "Prześlij CV",
      "replace": "Zastąp CV",
      "uploadDescription": "Prześlij CV, aby wyodrębnić ustrukturyzowane dane profilu",
      "uploadLimit": "Maks. 10 MB — PDF, DOCX, PNG, JPG, WEBP",
      "viewOriginal": "Zobacz oryginalne CV",
      "status": {
        "pending": "W kolejce",
        "processing": "Przetwarzanie...",
        "done": "Przetworzono",
        "failed": "Przetwarzanie nie powiodło się"
      },
      "parsed": {
        "title": "Wyodrębniony profil",
        "skills": "Umiejętności",
        "experience": "Doświadczenie",
        "education": "Wykształcenie",
        "languages": "Języki",
        "certifications": "Certyfikaty",
        "present": "Obecnie"
      },
      "errors": {
        "unsupportedType": "Nieobsługiwany typ pliku. Prześlij plik PDF, DOCX, PNG, JPG lub WEBP.",
        "tooLarge": "Plik zbyt duży. Maksymalny rozmiar to 10 MB.",
        "uploadFailed": "Nie udało się przesłać CV. Spróbuj ponownie."
      }
    }
  },
  "results": {
    "exportLabel": "Eksportuj",
    "exportCsv": "Eksportuj CSV",
    "csv": {
      "headers": {
        "candidateName": "Imię i nazwisko kandydata",
        "email": "E-mail",
        "role": "Rola",
        "stage": "Etap",
        "overallScore": "Wynik ogólny",
        "outcome": "Rezultat",
        "eligibility": "Kwalifikowalność",
        "expectations": "Oczekiwania",
        "avgScore": "Średni wynik",
        "interviewDate": "Data rozmowy",
        "status": "Status"
      }
    },
    "emptyTitle": "Brak wyników",
    "emptyDescription": "Ukończone rozmowy pojawią się tutaj.",
    "columns": {
      "candidate": "Kandydat",
      "stage": "Etap",
      "status": "Status",
      "score": "Wynik",
      "outcome": "Rezultat",
      "eligibility": "Kwalifikowalność",
      "expectations": "Oczekiwania",
      "avgScore": "Średni wynik",
      "interviewDate": "Data rozmowy",
      "question": "Pytanie"
    },
    "statusLabels": {
      "pending": "Oczekujące",
      "processing": "Przetwarzanie",
      "completed": "Ukończone",
      "failed": "Nieudane",
      "no_interview": "Brak rozmowy"
    },
    "questionSections": {
      "eligibility": "Kwalifikowalność",
      "job_preview": "Oczekiwania",
      "nice_to_have": "Mile widziane",
      "assessment": "Ocena",
      "information": "Informacje"
    },
    "fields": {
      "reasoning": "Uzasadnienie",
      "evidence": "Dowody",
      "response": "Odpowiedź",
      "avgScoreLabel": "Średni wynik",
      "interviewDate": "Data rozmowy"
    }
  },
  "orgSettings": {
    "title": "Ustawienia organizacji",
    "branding": {
      "title": "Branding",
      "logo": "Logo organizacji",
      "logoDescription": "Prześlij logo, aby zastąpić domyślne logo Kiku w pasku nawigacji.",
      "uploadLogo": "Prześlij logo",
      "removeLogo": "Usuń logo",
      "logoHint": "PNG, JPG, WebP lub SVG. Maks. 2 MB.",
      "uploadSuccess": "Logo zaktualizowane pomyślnie",
      "removeSuccess": "Logo usunięte",
      "uploadError": "Nie udało się przesłać logo"
    },
    "timezone": {
      "title": "Strefa czasowa",
      "description": "Ustaw domyślną strefę czasową do planowania i wyświetlania dat.",
      "label": "Strefa czasowa",
      "saveSuccess": "Strefa czasowa zaktualizowana",
      "saveError": "Nie udało się zaktualizować strefy czasowej"
    },
    "save": "Zapisz zmiany"
  },
  "mcp": {
    "title": "Integracja MCP",
    "subtitle": "Połącz asystentów AI z Kiku za pomocą Model Context Protocol",
    "whatIsMcp": "Czym jest MCP?",
    "whatIsMcpDescription": "Model Context Protocol (MCP) umożliwia asystentom AI, takim jak Claude, ChatGPT i innym narzędziom, bezpośrednią interakcję z Kiku — przeglądanie ofert pracy, wyświetlanie kandydatów i zarządzanie procesem rekrutacji za pomocą języka naturalnego.",
    "serverUrl": "URL serwera",
    "copyUrl": "Kopiuj URL",
    "copied": "Skopiowano!",
    "availableTools": "Dostępne narzędzia",
    "toolListJobs": "Wyszukaj i wyświetl oferty pracy z nazwami działów, filtrami statusu, statusu konfiguracji i działu.",
    "toolGetJob": "Pobierz pełne szczegóły konkretnej oferty pracy, w tym nazwę działu.",
    "toolCreateJob": "Utwórz nową ofertę pracy w dziale.",
    "toolAdvanceSetup": "Przejdź do kolejnego etapu konfiguracji oferty (szkic, pytania_oczekujące, gotowa, aktywna).",
    "toolListApplications": "Wyświetl aplikacje na stanowisko z nazwami etapów, statusem oceny i wynikiem.",
    "toolGetInterviewResults": "Pobierz wyniki wywiadu AI dla aplikacji — wynik, rezultat i rozbicie na pytania z uzasadnieniem.",
    "toolGetPipelineSummary": "Pobierz podsumowanie pipeline dla stanowiska — liczba kandydatów na etap z sumami zdanych/niezdanych.",
    "setupTitle": "Konfiguracja z Claude Desktop",
    "setupStep1": "Otwórz Claude Desktop",
    "setupStep2": "Kliknij Customize w lewym pasku bocznym",
    "setupStep3": "Kliknij Connectors, następnie ikonę +, następnie Add custom connector",
    "setupStep4": "Wpisz Name: Kiku i URL serwera pokazany powyżej",
    "setupStep5": "Kliknij Add — Claude może teraz korzystać z Twoich danych Kiku"
  }
}
